import { TranslateService } from '@ngx-translate/core';
import { take, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { SignatorySignatureType } from './signatory-signature-type';

export class SignatureType {

    arr: SignatorySignatureType[];

    private translateInit = 'envelope.signatory.signatureType.';
    private translateInitContacts = 'contacts.signatureType.';

    constructor(private translate: TranslateService) {
    }

    public Init(): Observable<any> {
        return this.translate.get(
            [this.translateInit.concat('both_female'),
            this.translateInit.concat('digital'),
            this.translateInit.concat('electronics'),
            this.translateInit.concat('in_person'),
            this.translateInit.concat('selfie')]).pipe(
                take(1),
                map(x => {
                    this.arr = [
                        { id: 0, value: x[this.translateInit.concat('both_female')], mask: this.translateInitContacts.concat('both_female')},
                        { id: 1, value: x[this.translateInit.concat('digital')], mask: this.translateInitContacts.concat('digital') },
                        { id: 2, value: x[this.translateInit.concat('electronics')], mask: this.translateInitContacts.concat('electronics') },
                        { id: 3, value: x[this.translateInit.concat('in_person')], mask: this.translateInitContacts.concat('in_person') },
                        { id: 5, value: x[this.translateInit.concat('selfie')], mask: this.translateInitContacts.concat('selfie') }
                    ];
                    return of();
                })
            );
    }

    public List(): Array<SignatorySignatureType> {
        return [...this.arr]; // returns a new instance of the array to guarantee immutability
    }

    public Get(id): any {
        if (id === null || id === undefined || id === '') {
            return undefined;
        }

        return this.arr.find(x => x.id === Number(id));
    }

    public GetValue(id): string {
        switch (id) {
            case 0:
                return this.translateInit.concat('both_female');
                break;
            case 1:
                return this.translateInit.concat('digital');
                break;
            case 2:
                return this.translateInit.concat('electronics');
                break;
            case 3:
                return this.translateInit.concat('in_person');
                break;
            case 5:
                return this.translateInit.concat('selfie');
                break;
        }
    }
}
